import React from "react";
import { User } from "~/common/Store/connectUserAndChat";
import MainWindow from "../MainWindow";
import ModelViewer from "../ModelViewer";
import { ModelViewerProvider } from "../ModelViewer/ModelScene/three/hooks/useModel3D";

interface Props {
  user: User;
  isLoadingCart: boolean;
  openModal: () => void;
  isTrs: boolean;
}

const Customizer = ({ user, openModal, isLoadingCart, isTrs }: Props) => {
  return (
    <div className="container customize__container customize__split-container flex box-content">
      <ModelViewerProvider>
        <MainWindow
          user={user}
          openModal={openModal}
          loadingCart={isLoadingCart}
          isTrs={isTrs}
        />
        <div className="box customize__box customize__box--hide customize__split">
          <div className="customize__box-fill">
            <div className="customize__disclaimer box">
              Note – preview is approximate, and final printing dimensions and
              scale may vary.
            </div>
          </div>
          <ModelViewer />
        </div>
      </ModelViewerProvider>
    </div>
  );
};

export default Customizer;
